export enum ROUTES {
  HOME = '/',
  LOGIN = '/login',
  COMPANIES = '/companies',
  COMPANY_DETAILS = '/companies/:slug',
  CHECK_IN = '/checkin',
  SELECT_TOPIC = '/select-topic',
  THANK_YOU = '/thankyou',
  UPDATE_MY_INFO = '/update-my-info',
}